import React from 'react';
import Icon from '../../components/Icon';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const LessonHow = ({isOpen, onClose}) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} contentLabel="Example Modal">
      <div className="row align-items-center justify-content-between mb-4">
        <div className="col-auto">
          <div className="font-4">Подсказка</div>
        </div>
        <div className="col-auto">
          <button className="btn p-2 font-2" onClick={onClose}>
            Закрыть <Icon name="times" />
          </button>
        </div>
      </div>
      <div className="overflow-auto pb-4">
        <span className="fw-bolder font-4">Уроки:</span>
        <br />
        <br />
        Каждый урок состоит из элементов: <span className="fw-bolder">Лексика, Грамматика и Фонетика.</span>
        <br />
        Для прохождения урока нужно пройти эти элементы
        <br />
        <br />
        Фонетика: прочитать.
        <br />
        Лексика: прочитать; выполнить практическое задание.
        <br />
        Грамматика: прочитать; выполнить практическое задание; пройти финальный тест.
        <br />
        <br />
        В большинстве тестов есть функция “дополнительной информации”, откройте ее при малейшем затруднении
        <br />
        <br />
        {/* Есть четыре режима скорости обучения:
        <br />
        <span className="fw-bolder">Нормальный:</span> 1 урок в день (рекомендуется)
        <br />
        <span className="fw-bolder">Ускоренный:</span> 2 урока в день
        <br />
        <span className="fw-bolder">Быстрый:</span> 3 урока в день
        <br />
        <span className="fw-bolder">Неограниченный</span>
        <br />
        По умолчанию установлен нормальный режим. Скорость можно поменять в настройках
        <br />
        <br /> */}
        После прохождения 5-и уроков идет <span className="fw-bolder">тест-повторение</span> из грамматики пройденных
        уроков.
        <br />
        <br />
        Всего уроков 75
        <br />
        <br />
        <br />
        <span className="fw-bolder font-4">Древо:</span>
        <br />
        <br />
        В древе отображены главные темы грамматики казахского языка
        <br />
        <br />
        Цель: показать из каких элементов состоит казахский язык
        <br />
        <br />
        Темы обозначены звездами в соответствии с важностью
        <br />
        <br />
        5 звезд: критически важно знать для передачи мысли
        <br />
        <br />
        1-2 звезды: для передачи мысли можно обойтись без них, но важно понимать их в речи собеседника
        <br />
        <br />
        По мере прохождения уроки будут отображаться в древе зеленой галочкой
        <br />
        <br />
        Некоторые темы изучаются в двух или более уроках
      </div>
    </Modal>
  );
};

export default LessonHow;
